export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref7266.a623ed45.jpg";